import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "components/Image/Image";
import classes from "./BlogCard.module.css";
import { formatTitle } from "util/helper";

const BlogCard = (props) => {
  return (
    <a href={`/blogs/${props.blog.id}`} className={classes["blog-card"]}>
      {props.blog["thumbnail_url"] && (
        <div className={classes["thumbnail-wrapper"]}>
          <div className={classes["thumbnail-cover"]}>
            <p className={classes["thumbnail-cover__text"]}>Read now</p>
          </div>
          <Image src={props.blog["thumbnail_url"]} alt="thumbnail_url" />
        </div>
      )}
      <div className={classes["blog-card__info"]}>
        <h3 className={classes["blog-card__title"]}>
          {formatTitle(props.blog.title.rendered)}
        </h3>
        <p className={classes["blog-card__excerpt"]}>{props.blog.excerpt}</p>
        <p className={classes["blog-card__time"]}>
          <FontAwesomeIcon icon={faClock} /> {props.blog.read_time}
        </p>
      </div>
    </a>
  );
};

export default BlogCard;
